<template>
  <v-row>
    <v-dialog
      v-model="detailDialog"
      max-width="888px"
      min-width="500px"
      persistent
      class="customerEDIInfo"
    >
      <template v-slot:activator="{ on }">
        <v-btn v-if="!!btnTxt" text v-on="on" small>
          <div>
            <div class="footer-agent-list">{{ btnTxt }}</div>
          </div>
        </v-btn>
        <v-btn v-else text icon v-on="on" small class="pl-4">
          <div>
            <v-icon x-small>fa fa-edit</v-icon>
          </div>
        </v-btn>
      </template>

      <v-card>
        <v-row class="pb-0">
          <v-col cols="11" class="pl-5">
            <v-card-title class="content-header-company" primary-title
              >{{ title }}
            </v-card-title>
          </v-col>
          <v-col cols="1" class="pr-10">
            <v-btn small text icon @click="close()">
              <icon-svg iconName="close" />
              <!--<v-icon >fa fa-times</v-icon>-->
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="v-dialog-1 dialog-company-Detail add-map-layout-dialog">
        <system-progress
          :sysloading="isLoading"
        ></system-progress>
        <v-row>
          <v-col cols="6" class="pb-0">
            <v-label
              ><span>{{
                $t("lbl.agents.agentInfo")
              }}</span></v-label
            >
          </v-col>
          <v-col cols="6" class="pl-4 pb-0">
            <v-label
              ><span>{{
                $t("lbl.agents.dbInfo")
              }}</span></v-label
            >
          </v-col>
        </v-row>
        <v-card-text class="pa-0">
          <v-row>
            <v-col cols="6">
              <v-form
                ref="form"
                class="dialog-content form-identification form-company"
              >
                <v-row class="ml-0 mr-0 mb-1">
                  <v-col cols="12" class="pa-0">
                    <v-label
                      ><v-icon x-small class="mr-1">fa fa-asterisk</v-icon
                      ><span>{{
                        $t("lbl.partners.company")
                      }}</span></v-label
                    >
                    <v-autocomplete
                      v-model="getValue.compId"
                      :rules="rules.compId"
                      :items="getCompanyList"
                      v-if="
                        getValue.compIdCheck === getValue.ownrId
                      "
                      item-text="compNm"
                      item-value="compId"
                      :disabled="!!getValue.agentId"
                      ref="compId"
                      class="custom-selectbox"
                      height="30"
                      solo
                    ></v-autocomplete>
                    <v-autocomplete
                      v-model="getValue.compId"
                      v-else
                      :rules="rules.compId"
                      :items="getCompanyList"
                      item-text="compNm"
                      item-value="compId"
                      ref="compId"
                      class="custom-selectbox"
                      height="30"
                      solo
                      disabled
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row class="ml-0 mr-0 mb-1">
                  <v-col cols="12" class="pa-0">
                    <v-label
                      ><v-icon x-small class="mr-1">fa fa-asterisk</v-icon
                      ><span>{{
                        $t("lbl.agents.agentNm")
                      }}</span></v-label
                    >
                    <v-text-field
                      ref="agentNm"
                      v-model="getValue.agentNm"
                      :rules="rules.agentNm"
                      heigth="30"
                      solo
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="ml-0 mr-0 mb-1">
                  <v-col cols="12" class="pa-0">
                    <v-label
                      ><v-icon x-small class="mr-1">fa fa-asterisk</v-icon
                      ><span>{{
                        $t("lbl.agents.agentIP")
                      }}</span></v-label
                    >
                    <v-text-field
                      ref="agentAddress"
                      v-model="getValue.agentAddress"
                      :rules="rules.agentAddress"
                      heigth="30"
                      solo
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="ml-0 mr-0 mb-1">
                  <v-col cols="12" class="pa-0">
                    <v-label
                      ><v-icon x-small class="mr-1">fa fa-asterisk</v-icon
                      ><span>{{
                        $t("lbl.agents.port")
                      }}</span></v-label
                    >
                    <v-text-field
                      ref="agentPort"
                      v-model="getValue.agentPort"
                      :rules="rules.agentPort"
                      heigth="30"
                      solo
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-col>
            <!-- /*
            * 2021.20.07 203737 SPKA-159 issue 107 Add "Character Set" Item 
            */ -->
            <v-col cols="6" class="pl-1">
              <v-row class="ml-0 mb-6">
                <v-col cols="12">
                  <v-form
                    ref="formEDI"
                    class="
                      dialog-content
                      form-identification
                      edi-iden-company-list
                      pr-0
                      pb-4
                    "
                  >
                    <v-row class="ml-0 mr-0">
                      <v-col lg="5" class="pa-0">
                        <v-label
                          ><span>{{
                            $t("lbl.agents.dbIns")
                          }}</span></v-label
                        >
                      </v-col>
                      <v-col lg="5" class="pa-0 ml-2">
                        <v-label
                          ><span>{{
                            $t("lbl.agents.table")
                          }}</span></v-label
                        >
                      </v-col>
                      <v-col lg="1" class="pa-0 ml-3 mr-0">
                        <v-icon dense @click="addDB()"> mdi-plus </v-icon>
                      </v-col>
                    </v-row>
                    <v-row
                      class="ml-0 mr-0 mb-3 edi-identification"
                      v-show="item.flag != 'D'"
                      v-for="(item, index) in listDB"
                      :key="item.id"
                    >
                      <v-col lg="5" class="pa-0">
                        <v-text-field
                          :ref="'EDI_' + item.id"
                          :maxlength="50"
                          solo
                          hide-details
                          v-model="item.dbInstance"
                          :disabled="item.flag != 'I'"
                          :readonly="item.flag != 'I'"
                          :class="[
                            item.flag != 'I' ? 'custome-edi-not-allowed' : '',
                          ]"
                        ></v-text-field>
                      </v-col>
                      <v-col lg="5" class="pa-0 ml-2">
                        <v-text-field
                          :ref="'EDI_' + item.id + '_' + item.id"
                          :maxlength="50"
                          solo
                          hide-details
                          v-model="item.dbTable"
                          @change="changeDB(item, index)"
                        ></v-text-field>
                      </v-col>
                      <v-col lg="1" class="pa-0 ml-3 mr-0 mt-2">
                        <v-tooltip top disabled>
                          <template v-slot:activator="{ on }">
                            <div v-on="on" class="btn-tooltip">
                              <v-icon
                                dense
                                @click="removeDB(item, index)"
                              >
                                mdi-minus
                              </v-icon>
                            </div>
                          </template>
                          <span
                            v-html="$t('lbl.processSetup.ediInUseWF')"
                          ></span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-divider class="ml-0 mr-0 mt-3 divder-popup" inset></v-divider>
        </v-card-text>

        <v-row class="ml-0 mr-0">
          <v-col class="button-col p-0" lg="12">
            <div class="btn-form-control text-right mb-0">
              <v-btn class="btn btn-delete btn-popup" @click="close()">
                {{ $t("lbl.company.close") }}
              </v-btn>
              <v-btn
                class="btn btn-search btn-popup"
                color="primary"
                @click="save()"
              >
                {{ $t("lbl.company.save") }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <dialogWindow
      ref="companySaveDialog"
      size="max"
      :detail="checkDialogInfo"
      :color="checkDialogColor"
      @select-ok="removeDialog()"
    >
    </dialogWindow>
  </v-row>
</template>

<script>
import dialogWindow from "@/vue-dlb/components/NewDialog.vue";
import IconSvg from "@/vue-caas/components/IconBase.vue";
import SystemProgress from "@/vue-dlb/components/SystemProgress.vue";

export default {
  components: {
    dialogWindow,
    IconSvg,
    SystemProgress
  },
  props: {
    btnTxt: {
      default: "",
    },
    btnIcon: {
      default: "",
    },
    title: {
      default: "",
    },
    dataValue: {
      default: function () {
        return {
          compId: "",
          agentId: "",
          agentNm: "",
          agentAddress: "",
          agentPort: "",
        };
      },
    },
  },
  data() {
    return {
      detailDialog: false,
      value: {},
      checkResult: "",
      idFocus: "",
      rules: {
        compId: [(v) => !!v || "Company is required"],
        agentNm: [
          (v) => !!v || "Agent Name is required",
          (v) => !v || v.length <= 100 || "Agent Name max length is 100.",
        ],
        agentAddress: [
          (v) => !!v || "Agent Address is required",
          (v) => !v || v.length <= 100 || "Agent Address max length is 100.",
        ],
        agentPort: [
          (v) => !!v || "Agent Port is required",
          (v) => !v || v.length <= 5 || "Agent Port max length is 5.",
        ],
      },
      formHasErrors: false,
      dupErr: false,
      dupErrMsg: "",
      checkDialogInfo: "",
      checkDialogColor: "success",
      listDB: [],
      characterSetList: [],
      companyList: [],
      agentInfo: {},
      isLoading: false,
    };
  },

  watch: {
    detailDialog() {
      if (this.detailDialog) {
        this.initializedData();
        
        if (this.getValue.agentId) this.getDBList();
      }
    },
  },

  computed: {
    getValue() {
      return this.value;
    },
    formData() {
      return {
        compId: this.getValue.compId,
        agentNm: this.getValue.agentNm,
        agentAddress: this.getValue.agentAddress,
        agentPort: this.getValue.agentPort,
      };
    },
    getCompanyList() {
      this.companyList = this.$store.getters.companies;
      return this.companyList;
    },
  },

  created() {
    this.initializedData();
    if (this.getValue.agentId) this.getDBList();
    //this.getCharacterSetList();
  },

  methods: {
    addDB() {
      let index =
        this.listDB.length > 0 ? this.listDB[this.listDB.length - 1].id + 1 : 1;
      this.listDB.push({
        id: index,
        dbInfoId: "",
        dbInstance: "",
        dbTable: "",
        flag: "I",
      });
    },
    removeDB(item, index) {
      if (item.flag == "I") {
        this.listDB.splice(index, 1);
      } else {
        this.listDB[index].flag = "D";
      }
    },
    // 2021.5.7 203728 Add update EDI
    changeDB(item, index) {
      if (item.flag != "I") {
        this.listDB[index].flag = "U";
      }
    },
    getDBList() {
      this.$store
        .dispatch("getAgentDBList", { agentId: this.getValue.agentId })
        .then(() => {
          this.listDB = [];
          if (this.$store.getters.agentDBList.length > 0) {
            this.$store.getters.agentDBList.map((e, i) => {
              this.listDB.push({
                id: i + 1,
                dbInfoId: e.dbInfoId,
                dbInstance: e.dbInstance,
                dbTable: e.dbTable,
                flag: "N",
              });
            });
          }
        });
    },
    initializedData() {
      if (this.$refs.form !== undefined) {
        this.$refs.form.reset();
      }

      if (
        this.dataValue !== undefined &&
        this.dataValue !== null &&
        JSON.stringify(this.dataValue) !== JSON.stringify({})
      ) {
        this.value = JSON.parse(JSON.stringify(this.dataValue));
        this.value.compIdCheck = this.$cookies.get('comp-id');
        this.value.ownrId = this.$cookies.get('ownr-id');
        if (this.value.compIdCheck !== this.value.ownrId) {
          this.value.compId = this.$cookies.get('comp-id');
        }
      } else {
        this.resetValue();
      }
    },
    resetValue() {
      this.value = {
        compId: "",
        agentNm: "",
        agentAddress: "",
        agentPort: "",
      };
    },
    save() {
      try {
        this.formHasErrors = false;
        Object.keys(this.getValue).forEach((key) => {
          if (this.$refs[key] !== undefined) {
            // alert(`${key} : ${this.formData[key]}`);
            if (!this.formData[key] || this.formData[key] === "") {
              this.formHasErrors = true;
            }

            this.$refs[key].validate(true);
          }
        });
        if (!this.getValue.compId) {
          this.$refs.compId.focus();
        } else if (!this.getValue.agentNm) {
          this.$refs.agentNm.focus();
        } else if (!this.getValue.agentAddress) {
          this.$refs.agentAddress.focus();
        } else if (!this.getValue.agentPort) {
          this.$refs.agentPort.focus();
        }
        if (!this.formHasErrors) {
          this.isLoading = true;
          // 2021.5.7 203728 Remove check Qual
          let index = this.listDB.find((e) => e.dbInstance == "" || e.dbTable == "");
          if (index) {
            return this.$refs[
              `EDI_${index.id}${index.dbInstance == "" ? "" : "_" + index.id}`
            ][0].focus();
          }
          let listDBCheck = this.listDB;
          let arrChk = listDBCheck.map((e) => {
            e.dbInsCheck = e.dbInstance.toLowerCase();
            e.dbTableCheck = e.dbTable.toLowerCase();
            return e.dbInsCheck + e.dbTableCheck;
          });
          let isDuplicate = arrChk.findIndex((e, i) => {
            return arrChk.indexOf(e) != i;
          });

          if (isDuplicate > -1) {
            this.checkDialogInfo = "DB Instance is duplicate.";
            this.checkDialogColor = "validation";
            this.isLoading = false;
            this.$refs.companySaveDialog.dialog = true;
            this.idFocus = `EDI_${isDuplicate + 1}`;
            return;
          }

          this.value.dbList = this.listDB.filter((e) => e.flag);
          this.value.dbList.map((e) => {
            e.dbTable = e.dbTable.trim();
          });
          this.getValue.agentName = this.getValue.agentNm;
          if (this.getValue.agentId) {
            this.$store
              .dispatch("updateAgent", this.getValue)
              .then(() => {
                this.checkDialogInfo = `${this.getValue.agentNm} has been updated successfully.`;
                this.checkDialogColor = "success";
                this.isLoading = false;
                this.$refs.companySaveDialog.dialog = true;
              })
              .catch((err) => {
                this.checkDialogInfo = `Exception occured updating ${this.getValue.agentNm} agent info.\nReason: ${err}`;
                this.checkDialogColor = "error";
                this.isLoading = false;
                this.$refs.companySaveDialog.dialog = true;
              });
          } else {
            this.$store
              .dispatch("insertAgent", this.getValue)
              .then(() => {
                this.checkDialogInfo = `${this.getValue.agentNm} has been created successfully.`;
                this.checkDialogColor = "success";
                this.isLoading = false;
                this.$refs.companySaveDialog.dialog = true;
              })
              .catch((err) => {
                this.checkDialogInfo = `Exception occured creating ${this.getValue.agentNm} agent info.\nReason: ${err}`;
                this.checkDialogColor = "error";
                this.isLoading = false;
                this.$refs.companySaveDialog.dialog = true;
              });
          }
        }
      } catch (err) {
        this.checkDialogInfo = `Exception occured.\nReason: ${err}`;
        this.checkDialogColor = "error";
        this.isLoading = false;
        this.$refs.companySaveDialog.dialog = true;
      }
    },

    close() {
      this.resetValue();
      this.$refs.form.reset();
      this.listDB = [];
      this.detailDialog = false;
      
    },

    check(val) {
      const pattern =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (!pattern.test(val)) {
        this.$store.dispatch("checkCompany", this.getValue).then(() => {
          if (this.$store.getters.duplicate.compId) {
            this.checkResult = this.$store.getters.duplicate.compId;
          }
        });
      }
    },

    clearDupErr() {
      this.dupErr = false;
      this.dupErrMsg = "";
    },

    removeDialog() {
      if (this.idFocus) {
        let self = this;
        return setTimeout(() => {
          self.$refs[self.idFocus][0].focus();
        }, 300);
      }

      this.resetValue();
      this.$refs.companySaveDialog.dialog = false;
      this.listDB = [];
      this.detailDialog = false;
      this.$emit("refreshAgentList");
      // 2021.3.16 203728 SPKA-52 => bug 13
    },
  },
};
</script>
<style>
.footer-agent-list {
  padding-top: 0px;
  padding-bottom: 14px;
  padding-left: 2px;
}
.theme--dark .footer-agent-list {
  color: #0082ba !important;
  text-decoration: underline;
}
.theme--light .footer-agent-list {
  color: #606268 !important;
}
</style>